// @ts-nocheck
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import SliderImport from "react-slick";
import {SectionHeader} from "@/components";

// Bun's CJS interop may return the whole module namespace; normalize to default.
// biome-ignore lint/suspicious/noExplicitAny: react-slick CJS interop normalization
const Slider: any = (SliderImport as any)?.default ?? SliderImport;

import BoardGamesIcon from "../../../../../assets/images/all-game-list-icons/board-games.svg";
import CasinoIcon from "../../../../../assets/images/all-game-list-icons/casino.svg";
import EGamesIcon from "../../../../../assets/images/all-game-list-icons/e-games.svg";
import HorsesIcon from "../../../../../assets/images/all-game-list-icons/horses.svg";
import LotteryIcon from "../../../../../assets/images/all-game-list-icons/lottery.svg";
import MiniGamesIcon from "../../../../../assets/images/all-game-list-icons/mini-games.svg";
import SlotsIcon from "../../../../../assets/images/all-game-list-icons/slots.svg";
import SportsIcon from "../../../../../assets/images/all-game-list-icons/sports.svg";
import CrownIcon from "../../../../../assets/images/icon-crown.svg";

const allGamesContainerCls =
  "w-full h-auto m-0 rounded-[var(--radius-lg)] py-[var(--space-6)] px-[var(--space-5)] box-border max-[1200px]:py-4 max-[1200px]:px-3";
const allGamesHeaderCrownCls =
  "inline-block w-[1em] h-[1em] object-contain drop-shadow-[0_4px_12px_rgba(253,238,51,0.25)]";
const allGamesSliderWrapperCls =
  "h-full [&_.slick-track]:flex [&_.slick-track]:items-center [&_.slick-list]:!overflow-x-clip [&_.slick-list]:!overflow-y-visible [&_.slick-list]:py-3 [&_.slick-list]:-my-3 [&_.slick-list]:mx-[-5px] [&_.slick-slide]:!flex [&_.slick-slide]:justify-center [&_.slick-slide]:px-[var(--space-1-5)] [&_.slick-slide>div]:flex [&_.slick-slide>div]:justify-center [&_.slick-slide>div]:w-full";
const allGamesCardCls =
  "surface-elev-2 group/cat relative overflow-hidden !w-full aspect-square !flex flex-col items-center justify-center gap-2.5 rounded-[var(--radius-lg)] ring-1 ring-[var(--color-border-subtle)] cursor-pointer transition-[transform,box-shadow,background] duration-[var(--transition-normal)] box-border p-3 hover:-translate-y-[3px] hover:ring-transparent hover:!bg-[linear-gradient(90deg,rgb(250,84,0)_0%,rgb(215,50,168)_100%)] hover:shadow-[0_0_0_1px_rgba(253,238,51,0.15),0_12px_36px_rgba(215,50,168,0.55),0_0_24px_rgba(250,84,0,0.35)] before:content-[''] before:pointer-events-none before:absolute before:top-0 before:-left-3/4 before:h-full before:w-1/2 before:bg-[linear-gradient(115deg,transparent_0%,rgba(255,255,255,0)_30%,rgba(255,255,255,0.45)_50%,rgba(255,255,255,0)_70%,transparent_100%)] before:skew-x-[-20deg] before:opacity-0 group-hover/cat:before:opacity-100 hover:before:animate-[card-flare_0.9s_ease-out]";
const allGamesCardActiveCls =
  "!bg-[linear-gradient(90deg,rgb(250,84,0)_0%,rgb(215,50,168)_100%)] ring-transparent shadow-[0_12px_28px_rgba(215,50,168,0.4)]";
const allGamesIconWrapperCls =
  "w-[55%] aspect-square flex-shrink-0 transition-[background,transform] duration-[var(--transition-normal)] group-hover/cat:scale-[1.06] bg-[#9696a3] group-hover/cat:bg-white";
const allGamesIconActiveCls = "!bg-white";
const allGamesTitleCls =
  "text-[var(--color-text)] font-[var(--font-family-display)] font-semibold text-(length:--font-h2) leading-[1.25] text-center m-0 capitalize tracking-tight px-1";

const games = [
  {
    id: 1,
    name: "loterias",
    route: "lottery",
    icon: LotteryIcon,
    labelKey: "allGamesLoterias",
    defaultLabel: "Loterías",
  },
  {
    id: 2,
    name: "hipismo",
    route: "horses",
    icon: HorsesIcon,
    labelKey: "allGamesHipismo",
    defaultLabel: "Hipismo",
  },
  {
    id: 3,
    name: "deportes",
    route: "sports",
    icon: SportsIcon,
    labelKey: "allGamesDeportes",
    defaultLabel: "Deportes",
  },
  {
    id: 4,
    name: "mini-juegos",
    route: "crash-games",
    icon: MiniGamesIcon,
    labelKey: "allGamesMiniJuegos",
    defaultLabel: "Mini Juegos",
  },
  {
    id: 5,
    name: "casino-live",
    route: "casino",
    icon: CasinoIcon,
    labelKey: "allGamesCasinoLive",
    defaultLabel: "Casino Live",
  },
  {
    id: 6,
    name: "slots",
    route: "gameslist/all",
    icon: SlotsIcon,
    labelKey: "allGamesSlots",
    defaultLabel: "Slots",
  },
  {
    id: 7,
    name: "juegos-de-mesa",
    route: "gameslist/board-games",
    icon: BoardGamesIcon,
    labelKey: "allGamesJuegosDeMesa",
    defaultLabel: "Juegos de Mesa",
  },
  {
    id: 8,
    name: "e-sports",
    route: "games/pragmatic/vplobby",
    icon: EGamesIcon,
    labelKey: "allGamesESports",
    defaultLabel: "E-Sports",
  },
];

const AllGamesList = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 600,
    slidesToShow: 8,
    slidesToScroll: 4,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
    ],
  };

  return (
    <div className={allGamesContainerCls}>
      <SectionHeader
        icon={
          <img
            src={CrownIcon}
            alt=""
            className={allGamesHeaderCrownCls}
          />
        }
        eyebrow="En vivo"
        title="Todos ya están coronando"
        highlight="coronando"
        align="center"
        variant="default"
      />
      <div className={allGamesSliderWrapperCls}>
        <Slider {...settings}>
          {games.map((game, index) => (
            <div
              key={game.id}
              className={`${allGamesCardCls} ${index === activeIndex ? allGamesCardActiveCls : ""}`}
              onClick={() => {
                setActiveIndex(index);
                navigate(`/${game.route}`);
              }}
            >
              <div
                className={`${allGamesIconWrapperCls} ${index === activeIndex ? allGamesIconActiveCls : ""}`}
                style={{
                  WebkitMaskImage: `url(${game.icon})`,
                  maskImage: `url(${game.icon})`,
                  WebkitMaskRepeat: "no-repeat",
                  maskRepeat: "no-repeat",
                  WebkitMaskPosition: "center",
                  maskPosition: "center",
                  WebkitMaskSize: "contain",
                  maskSize: "contain",
                }}
                role="img"
                aria-label={t(game.labelKey, {defaultValue: game.defaultLabel})}
              />
              <span className={allGamesTitleCls}>{t(game.labelKey, {defaultValue: game.defaultLabel})}</span>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default AllGamesList;
